<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.5977 28L29 23.5429V20.7571M21.5977 28L1 10.1714V7.57143M21.5977 28V24.9667M29 20.7571L21.5977 24.9667M29 20.7571V18.7143L7.43678 2V4.6M21.5977 24.9667L1 7.57143M1 7.57143L7.43678 4.6M7.43678 4.6V6.82857M7.43678 6.82857L24.7222 20.7571M7.43678 6.82857L5.09489 7.94286" stroke="#2D3843" stroke-width="1.25"/>
  </svg>

</template>

<script>
export default {
    name: 'SVGShelfForShelfLeft',
};
</script>

<style scoped>

</style>
